module.exports = __webpack_public_path__ + "static/media/rituals_logo_1.1@20x.56d519b5.png";